import React, { useContext } from "react";
import BigError from "../../Misc/BigError";
import { Route, Switch } from "react-router-dom";
import Context from "../../../Context";
import ActiveSessions from "./Widgets/ActiveSessions";
import EventLog from "./Widgets/EventLog";
import ApiLog from "./Widgets/ApiLog";
import EventCharts from "./Widgets/EventCharts";
import Registry from "./Widgets/Registry/Registry";
import ApiConsole from "./Widgets/ApiConsole";
import Areas from "./Widgets/Areas/Areas";
import AreasWidget from "./Widgets/AreasWidget";
import Users from "./Widgets/Users/Users";
import Groups from "./Widgets/Groups/Groups";
import Workflow from "./Widgets/Workflow/Workflow";

function Admin() {
  const cx = useContext(Context);
  cx.breadCrumbsAdd(cx.t("pages.admin.admin"), "/admin");
  if (!cx.user.isAuthorized || !cx.user.isAdmin) return null;

  return (
    <Switch>
      <Route path="/admin" exact>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="card card-custom gutter-b">
                <div className="card-body">
                  <EventCharts />
                </div>
              </div>
              <div className="card card-custom gutter-b ">
                <div className="card-body">
                  <AreasWidget />
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <ActiveSessions />
            </div>
          </div>
        </div>
      </Route>
      <Route path="/admin/workflow">
        <Workflow />
      </Route>
      <Route path="/admin/apiLog">
        <div className="container">
          <ApiLog />
        </div>
      </Route>
      <Route path="/admin/eventLog">
        <div className="container">
          <EventLog />
        </div>
      </Route>
      <Route path="/admin/registry">
        <div className="container mh100">
          <Registry />
        </div>
      </Route>
      <Route path="/admin/apiConsole">
        <div className="container">
          <ApiConsole />
        </div>
      </Route>
      <Route path="/admin/areas">
        <div className="container mh100">
          <Areas />
        </div>
      </Route>
      <Route path="/admin/users">
        <div className="container mh100">
          <Users />
        </div>
      </Route>
      <Route path="/admin/groups">
        <div className="container mh100">
          <Groups />
        </div>
      </Route>
      <Route path="*">
        <BigError
          title={cx.t("error.notFound.title")}
          message={cx.t("error.notFound.message")}
        />
      </Route>
    </Switch>
  );
}
export default Admin;
